<template>
  <div>
    <h2 class="pannel-titile input-title-hq" :class="{ 'red-required': isRequired }">{{pannelTitle}}</h2>
    <div class="upload-box">
      <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" :before-read="beforeRead" :after-read="afterRead" :before-delete="beforeDelete"></van-uploader>
    </div>
  </div>
</template>


<script>
import api from "@/fetch/api"
import Compressor from 'compressorjs';
import { Toast } from 'vant';
export default {
  data() {
    return {

    }
  },
  props: {
    //panel标题
    pannelTitle: {
      type: String,
      default: ""
    },
    //最大可上传数量
    maxCount:{
      type:String,
      default:""
    },
    //是否必填
    isRequired: {
      type: Boolean,
      default: true,
    },
    uploadType:{
      type:String,
      default:""
    },
    uploadTypeInfo:{
      type:String,
      default:""
    },
  },
  created() {
    //
  },
  computed: {
    //
  },
  methods: {
    onOversize() {
      Toast('文件大小不能超过 10Mb');
    },
    beforeRead(file) {
      let quality = 0.6;
      if (file.size < 4 * 1024 * 1024) {
        quality = 0.9;
      } else if (file.size >= 4 * 1024 * 1024 && file.size < 8 * 1024 * 1024) {
        quality = 0.8;
      } else {
        quality = 0.6;
      }

      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          quality: quality,
          success(result) {
            let newfile = new File([result], file.name, {
              type: file.type
            })
            resolve(newfile)
          },
          error(err) {
            console.log('图片压缩失败---->>>>>', err)
          }
        })

      });
    },
    afterRead(file)
    {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;

      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');

      switch (this.uploadType) {
        case "XSZ":
          switch (this.uploadTypeInfo) {
              case "uploadXszFront":
                api.uploadSteamXszFront(formData).then(function(res) {
                  that.dealPostData(file,res);
                }).catch(function() {
                  Toast.fail('上传图片失败，请重新再试');
                  setTimeout(() => {
                    file.status = 'failed';
                    file.message = '上传失败';
                  }, 1000);
                });
              break;
              case "uploadXszFyFront":
                api.uploadSteamXszFyFront(formData).then(function(res) {
                  that.dealPostData(file,res);
                }).catch(function() {
                  Toast.fail('上传图片失败，请重新再试');
                  setTimeout(() => {
                    file.status = 'failed';
                    file.message = '上传失败';
                  }, 1000);
                });
              break;
            }
        break;

      }
    },
    beforeDelete(){
      this.$emit("uploadTypeInfo",this.uploadTypeInfo);
    },
    dealPostData(file,res)
    {
      var resData = JSON.parse(res);
      if (resData.respCode == "0") {
        resData.uploadTypeInfo = this.uploadTypeInfo;
        resData.uploadType = this.uploadType;
        this.$emit("afterImageRead",resData);
      } else {
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
        Toast.fail(resData.message);
      }
    },

  }
}
</script>
<style lang="scss" scoped>
.pannel-titile {
    padding: 0.675rem 1rem;
    color: #646566;
}
.upload-box {
    margin: 0 1rem;
}
.last-bottom {
    padding-bottom: 0.625rem;
    border-bottom: 1px solid #ebedf0;
}

.red-required::before {
    position: absolute;
    left: 8px;
    color: #ee0a24;
    font-size: 14px;
    content: '*';
}
</style>
